import forumNav from '@/forumcomponents/forumNav'
import miniNav from '@/forumViews/contact/components/miniNav'
export const contact = [
	{
		path: '/forum/contact',
		name: '_forumContact',
		component: forumNav,
		children: [
			{
				path: '/forum/contact',
				redirect: '/forum/contact/list',
				component: miniNav,
				children: [
					{
						path: '/forum/contact/list',  //合作支持
						component: () => import('@/forumViews/contact/list'),
                    },
                    // {
					// 	path: '/forum/contact/list',  //媒体支持
                    //     name: 'forumMediaInquires'
                    // },
                    // {
					// 	path: '/forum/contact/list',  //学术合作机构
                    //     name: 'forumMediaInquires'
                    // },
                    // {
                    //     path: '/forum/contact/list',  //志愿者报名
                    //     name: 'forumVolunteer'
                    // }
				],
            }
		],
	},
]
